import { BaseDto } from "../base.dto";
import { ConfigurationDto } from "../module-configuration";
import { BillingProductDto } from '../billing-product';
import { BillingSubscriptionPriceDto } from '../billing-subscription-price';

export class BillingSubscriptionDto extends BaseDto{
  name: string;
  billingProductId: number;
  sequence?: number;
  isActive: boolean;
  billingProduct?: BillingProductDto;
  billingConfigurations?: ConfigurationDto[];
  effectivePrice?: BillingSubscriptionPriceDto;
  billingSubscriptionPrices?: BillingSubscriptionPriceDto[];
}